$(() => {
    $(".ghq-card-content__table").addClass("faq-table").removeClass("ghq-card-content__table");

    if (!sessionStorage.getItem(`${folder.id}/${article.id}/VIEW`)) {
        sessionStorage.setItem(`${folder.id}/${article.id}/VIEW`, null);
        $.post(`${Config.options.rootUrl}${Config.options.regionAndLanguage}faq/view/${folder.id}/${article.id}/${article.publicArticle}`);
    }

    if (localStorage.getItem(`${folder.id}/${article.id}/THUMBS_UP`) === 'checked') {
        $("#thumbsup").addClass("checked");
    } else if (localStorage.getItem(`${folder.id}/${article.id}/THUMBS_DOWN`) === 'checked') {
        $("#thumbsdown").addClass("checked");
    }

    $("input:radio").on("click", function (e) {
        const scoreInput = $(this),
              articlePath = `${folder.id}/${article.id}/${scoreInput.val()}`;

        if (scoreInput.is(".checked")) {
            localStorage.setItem(articlePath , "unchecked");
            scoreInput.prop("checked", false).removeClass("checked");
        } else {
            if (!localStorage.getItem(articlePath)) {
                $.post(`${Config.options.rootUrl}${Config.options.regionAndLanguage}faq/rate/${articlePath}`);
            }
            let checkedRadio = $("input:radio[name='" + scoreInput.prop("name") + "'].checked");
            if (checkedRadio.length > 0) {
                localStorage.setItem(articlePath, "unchecked");
                checkedRadio.removeClass("checked");
            }
            localStorage.setItem(articlePath, "checked");
            scoreInput.addClass("checked");
        }
    });
});
